module.exports = __webpack_public_path__ + "img/logo.f33b5afb.png";